import { Link, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { Button } from './ui/button';
import { useState, useEffect } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function Navbar() {
  const navigate = useNavigate();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);

  useEffect(() => {
    checkAuth();
  }, []);

  const checkAuth = async () => {
    try {
      const response = await axios.get(`${API}/auth/me`, {
        withCredentials: true
      });
      setIsAuthenticated(true);
      setUser(response.data);
    } catch (error) {
      setIsAuthenticated(false);
    }
  };

  const handleLogout = async () => {
    try {
      await axios.post(`${API}/auth/logout`, {}, { withCredentials: true });
      setIsAuthenticated(false);
      setUser(null);
      navigate('/');
    } catch (error) {
      console.error('Logout error:', error);
    }
  };

  return (
    <nav className="glass-morphism border-b border-slate-200 sticky top-0 z-50" data-testid="navbar">
      <div className="container mx-auto px-6 md:px-12 lg:px-24 py-4">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center" data-testid="navbar-logo">
            <img
              src="https://customer-assets.emergentagent.com/job_kochi-realty/artifacts/ojw054q1_TB%20Logo.png"
              alt="True Bridge"
              className="h-16"
            />
          </Link>

          <div className="flex items-center gap-5">
            <Link
              to="/properties"
              data-testid="navbar-properties"
              className="text-sm text-slate-600 hover:text-primary transition-colors font-medium"
            >
              Properties
            </Link>
            <Link
              to="/new-launches"
              data-testid="navbar-new-launches"
              className="text-sm text-slate-600 hover:text-primary transition-colors font-medium"
            >
              New Launches
            </Link>
            <Link
              to="/calculator"
              data-testid="navbar-calculator"
              className="text-sm text-slate-600 hover:text-primary transition-colors font-medium"
            >
              EMI Calculator
            </Link>

            {isAuthenticated ? (
              <>
                <Link to="/dashboard" data-testid="navbar-dashboard">
                  <Button variant="ghost" className="flex items-center gap-2">
                    {user?.name}
                  </Button>
                </Link>
                <Button
                  data-testid="navbar-logout"
                  variant="ghost"
                  onClick={handleLogout}
                  className="flex items-center gap-2"
                >
                  <LogOut className="w-4 h-4" />
                  Logout
                </Button>
              </>
            ) : (
              <>
                <Link to="/login" data-testid="navbar-login">
                  <Button variant="ghost">Login</Button>
                </Link>
                <Link to="/register" data-testid="navbar-register">
                  <Button className="bg-primary hover:bg-primary/90 text-white">Sign Up</Button>
                </Link>
              </>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
}